import { isDisabled } from "@testing-library/user-event/dist/utils";
import { useEffect, useState } from "react";
import Select from "react-select";

function CustomSelect(props) {
    let {
        options,
        handleChange = () => { },
        isMulti = false,
        value = "",
        labelKey,
        valKey,
        isSearchable = true,
        isClearaAble = true,
        label = "",
        errorMsg = "",
        isBottomBorder,
        size = "medium",
        placeholder = "",
        isDisabled = false
    } = props;

    options = options?.map((i) => ({
        label: i[labelKey],
        value: i[valKey],
        details: i
    }));

    const [selectedValue, setSelecteValue] = useState([]);

    const transformOption = (value) => {
        if (!value) return [];
        return value?.map((level) => ({
            value: level,
            label: level,
        }));
    };

    useEffect(() => {
        if (isMulti) {
            setSelecteValue(transformOption(value));
        }
    }, [value, isMulti]);


    const sizeStyles = {
        small1: { minHeight: "36px", fontSize: "14px" },
        small: { minHeight: "28px", fontSize: "14px" },
        medium: { minHeight: "36px", fontSize: "14px" },
        large: { minHeight: "44px", fontSize: "16px" },
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            border: isBottomBorder ? "none" : provided.border,
            borderBottom: isBottomBorder ? "1px solid #3a4b68" : provided.border,
            borderRadius: isBottomBorder ? 0 : provided.borderRadius,
            boxShadow: "none",
            minHeight: sizeStyles[size].minHeight,
            fontSize: sizeStyles[size].fontSize,
            "&:hover": {
                borderBottom: isBottomBorder
                    ? "1px solid #3a4b68"
                    : provided.borderBottom,
            },
        }),
        valueContainer: (provided) => ({
            ...provided,
            minHeight: sizeStyles[size].minHeight,

            padding: "0px 2px 1px 6px"
        }),
        input: (provided) => ({
            ...provided,
            margin: 0,
            padding: 0,
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#3a4b68',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: sizeStyles[size].minHeight,
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: "12px",     // 👈 smaller font
            padding: "2px 4px",   // 👈 reduce padding
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    };


    return (
        <div>
            <label htmlFor="" className="labelForASsign">
                {label}
            </label>
            <Select
                options={options}
                isSearchable={isSearchable}
                isClearable={isClearaAble}
                isDisabled={isDisabled}
                value={
                    isMulti
                        ? selectedValue
                        : options?.find((i) => i.value === value) || null
                }
                isMulti={isMulti}
                onChange={(e) => {
                    if (isMulti) {
                        let arr = e?.map((item) => item.value) || [];
                        handleChange(arr, e);
                        setSelecteValue(transformOption(arr));
                    } else {

                        handleChange(e?.value || "", e);
                    }
                }}
                closeMenuOnSelect={!isMulti}
                hideSelectedOptions={false}
                classNamePrefix="select"
                className="w-100"
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                placeholder={placeholder}
            />
            <div style={{ color: "#dc3545", fontSize: "0.875em" }}>{errorMsg}</div>
        </div>
    );
}

export default CustomSelect;
